if (!customElements.get('cristaux-product-details')) {
  customElements.define(
    'cristaux-product-details',
    class CristauxProductDetails extends HTMLElement {
      connectedCallback() {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data?.variant?.id) this.fetchVariantContent(event.data.variant.id);
        });
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      fetchVariantContent(variantId) {
        const variantSectionUrl = `${this.dataset.productUrl}?variant=${variantId}&section_id=${this.dataset.sectionId}`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const newRoot = new DOMParser().parseFromString(text, 'text/html').getElementById(this.id);
            if (newRoot) this.innerHTML = newRoot.innerHTML;
          });
      }
    }
  );
}
